"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = require("prop-types");

var _styledComponents = _interopRequireDefault(require("styled-components"));

var _Icons = require("../Icons");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

var StatusIcon = function StatusIcon(_ref) {
  var type = _ref.type,
      className = _ref.className,
      otherProps = _ref.otherProps;
  return /*#__PURE__*/_react.default.createElement(StyledStatusIcon, _extends({
    type: type,
    className: className
  }, otherProps), type === 'default' ? '?' : type === 'success' ? /*#__PURE__*/_react.default.createElement(_Icons.IconStatusCheck, {
    size: 11
  }) : type === 'warning' ? /*#__PURE__*/_react.default.createElement(_Icons.IconStatusExclamation, null) : type === 'error' ? /*#__PURE__*/_react.default.createElement(_Icons.IconActionClose, null) : '?');
};

var StyledStatusIcon = _styledComponents.default.div.withConfig({
  displayName: "StyledStatusIcon"
})(["width:1.8rem;height:1.8rem;display:flex;justify-content:center;align-items:center;border-radius:9999px;font-family:", ";font-weight:500;border:2px solid ", ";color:", ";> svg path{fill:", ";}"], function (_ref2) {
  var theme = _ref2.theme;
  return theme.font;
}, function (_ref3) {
  var theme = _ref3.theme,
      type = _ref3.type;
  return type === 'default' ? '#222' : type === 'success' ? theme.status.succes : type === 'warning' ? theme.status.warning : type === 'error' ? theme.status.error : null;
}, function (_ref4) {
  var theme = _ref4.theme,
      type = _ref4.type;
  return type === 'default' ? '#222' : type === 'success' ? theme.status.succes : type === 'warning' ? theme.status.warning : type === 'error' ? theme.status.error : null;
}, function (_ref5) {
  var theme = _ref5.theme,
      type = _ref5.type;
  return type === 'default' ? '#222' : type === 'success' ? theme.status.succes : type === 'warning' ? theme.status.warning : type === 'error' ? theme.status.error : null;
});

StatusIcon.defaultProps = {
  type: 'default'
};
StatusIcon.propTypes = {
  /** What type of icon should be displayed? ('default', 'success', 'warning', 'error') */
  type: _propTypes.string,

  /** Extra classnames to be passed to the element. */
  className: _propTypes.string,

  /** Extra props to be passed to the element. */
  otherProps: _propTypes.object
};
var _default = StatusIcon;
exports.default = _default;